import sample_1 from './twinstarProtect.jpg';

export const twinstarProtect = {
    sample_1,
};
